export { default as fetchData } from "./fetchData";
export { default as setMainScroll } from "./setMainScroll";
